import { cn } from "@/lib/utils";
import { Inbox, Loader2, AlertCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

export const LoadingState = ({ text = "Laster…", className }) => (
  <div data-testid="loading-state" className={cn("flex items-center justify-center gap-2 py-16 text-[13px] text-muted-foreground", className)}>
    <Loader2 className="h-4 w-4 animate-spin" /> {text}
  </div>
);

export const ErrorState = ({ error, onRetry, className }) => (
  <div data-testid="error-state" className={cn("flex flex-col items-center justify-center gap-2 py-16 text-center", className)}>
    <AlertCircle className="h-5 w-5 text-destructive" />
    <div className="text-[13px] font-medium">Kunne ikke laste data</div>
    <div className="max-w-md text-[12px] text-muted-foreground">{error?.response?.data?.detail?.toString?.() || error?.message}</div>
    {onRetry && (
      <Button size="sm" variant="outline" className="mt-1" onClick={onRetry} data-testid="error-retry-button">
        Prøv igjen
      </Button>
    )}
  </div>
);

export const EmptyState = ({ title = "Ingen data", description, action, icon: Icon = Inbox, className, testId = "table-empty-state" }) => (
  <div data-testid={testId} className={cn("flex flex-col items-center justify-center gap-1.5 py-14 text-center", className)}>
    <Icon className="mb-1 h-5 w-5 text-muted-foreground/70" strokeWidth={1.5} />
    <div className="text-[13px] font-medium">{title}</div>
    {description && <div className="max-w-sm text-[12px] leading-5 text-muted-foreground">{description}</div>}
    {action && <div className="mt-2">{action}</div>}
  </div>
);
